/* "Copy" button next to the email (contact page + footer).
   Both labels sit in the same spot, so the button never changes size. */
(function () {
  if (window.chitsCopyReady) return;
  window.chitsCopyReady = true;

  function fallbackCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    try {
      document.execCommand('copy');
    } catch (e) {}
    area.remove();
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.chits-copy');
    if (!btn) return;
    event.preventDefault();

    var text = btn.getAttribute('data-copy');
    if (!text) return;

    function done() {
      btn.classList.add('is-done');
      clearTimeout(btn._chitsTimer);
      btn._chitsTimer = setTimeout(function () {
        btn.classList.remove('is-done');
      }, 2000);
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(done, function () {
        fallbackCopy(text);
        done();
      });
    } else {
      fallbackCopy(text);
      done();
    }
  });
})();